const bookingReschedulePricingData = (state = null, action) => {
  if (action.type === "SET_BOOKING_RESCHEDULE_PRICING_DATA") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_BOOKING_RESCHEDULE_PRICING_DATA": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default bookingReschedulePricingData;
